import { dateToDisplay, dateTimeToDisplay } from './helpers';

const defaultFormatter = (value) => (value ? value.toString() : '');

const formatters = {
    date: dateToDisplay,
    dateTime: dateTimeToDisplay,
    number: (value) => value.toLocaleString(),
    boolean: (value) => (value ? 'Yes' : 'No')
};

export default (type) => formatters[type] || defaultFormatter;
